import { isNil } from "lodash";
import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

function PieChartWithPaddingAngle({ data, colors }) {
  const dataDefinition = data?.valor?.def ?? data;
  const hasDataDefinition = !isNil(dataDefinition);
 
  if (!hasDataDefinition) {  
      return null;
  }   

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={900} height={900}>
        <Pie
          data={dataDefinition}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          fill="#8884d8"
          paddingAngle={5}
          dataKey="value"
          label={(entry) => `${entry.name} (${entry.value})`}
        >
          {dataDefinition.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry?.fill || colors[index % colors.length]}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
}
export default PieChartWithPaddingAngle;
